import { MonitoringDailyReportPage } from '@/routes/elements';

const AtmPage = () => <MonitoringDailyReportPage />;

export default AtmPage;
